export const REGEX_CODFIS = '[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}';
export const REGEX_EMAIL = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$';
export const REGEX_EIDAS = '^(?=.{1,256}$)[A-Z]{2}/(?:[A-Z]{2}|EU)/(?:§+|[ A-Za-z0-9+/]+={0,2}|[A-Za-z0-9 ]+={0,2})$';
